// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#Image section { \r\n  padding-top: var(--menu-pad-wide-a);\n}\n@media (max-width: 750px) {\n#Image section {\r\n    padding-top: var(--menu-pad-mobile);\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
